import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-078c339e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "configuration-create",
  class: "d-flex flex-fill edit-page-40"
}
const _hoisted_2 = { class: "card border-0 background-fb" }
const _hoisted_3 = { class: "edit-header font-size-16" }
const _hoisted_4 = { class: "label" }
const _hoisted_5 = {
  class: "card-body overflow-auto font-size-14",
  id: "card-body"
}
const _hoisted_6 = {
  id: "configuration-draft",
  class: "d-flex flex-column"
}
const _hoisted_7 = { class: "d-flex flex-column" }
const _hoisted_8 = { class: "margin-top-10 d-flex flex-column" }
const _hoisted_9 = { class: "margin-top-10 d-flex flex-column" }
const _hoisted_10 = { class: "margin-top-10 d-flex flex-column" }
const _hoisted_11 = { class: "card-footer footer" }
const _hoisted_12 = { class: "float-right" }

import {
  ElButton,
  ElInput,
  ElInputNumber,
  ElSwitch,
  ElTooltip,
} from "element-plus";
import { computed, onBeforeMount, ref, watch } from "vue";
import { toInteger } from "lodash-es";
import { TYPE } from "vue-toastification";
import {
  addConfiguration,
  editConfiguration,
  getConfiguration,
} from "@/configuration/services/configuration.service";
import { currentRoute, router } from "@/core/router";
import { showAlert } from "@/core/popup";
import { hasPermission } from "@/core/auth";
import i18n from "@/core/i18n/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditConfigurations',
  setup(__props) {

const { t } = i18n.global;
const pageName = computed(() =>
  currentRoute.value.name === "createConfigurations"
    ? t("Common.Create")
    : t("Common.Edit")
);

const id = ref();
const level = ref();
const ownerId = ref();

const configuration = ref({
  key: "",
  level: "",
  ownerId: "",
  description: "",
  value: "",
  defaultValue: "",
  type: "",
  active: "",
  isPublic: "",
  deleted: "",
});

const booleanValue = ref();
const integerValue = ref(0);

const isValid = computed(
  () =>
    configuration.value.key &&
    configuration.value.value &&
    configuration.value.type
);

function isOverflowing(text?: string) {
  return (text?.length || 0) > 100;
}

async function saveConfiguration() {
  if (isValid.value && hasPermission("CONFIGURATIONS.CONFIGURATION.SAVE")) {
    if (id.value) {
      await editConfiguration(configuration.value).then((response) => {
        if (response) {
          showAlert(TYPE.SUCCESS, t("Configuration.ConfigurationUpdated"));
          router.push("/configurations");
        }
      });
    } else {
      await addConfiguration(configuration.value).then((response) => {
        if (response) {
          showAlert(TYPE.SUCCESS, t("Configuration.ConfigurationCreated"));
          router.push("/configurations");
        }
      });
    }
  } else if (hasPermission("CONFIGURATIONS.CONFIGURATION.SAVE")) {
    showAlert(TYPE.WARNING, t("Common.WarningMsg"));
  }
}

watch(
  () => booleanValue.value,
  (newValue) => {
    if (configuration.value.type === "BOOLEAN") {
      configuration.value.value = newValue ? "true" : "false";
    }
  }
);

watch(
  () => integerValue.value,
  (newValue) => {
    if (configuration.value.type === "INTEGER") {
      configuration.value.value = newValue.toString();
    }
  }
);

// Watch for changes to the main configuration object to update derived values
watch(
  () => configuration.value,
  (newConfig) => {
    if (
      newConfig &&
      newConfig.type === "BOOLEAN" &&
      newConfig.value !== undefined
    ) {
      booleanValue.value = newConfig.value === "true";
    } else if (
      newConfig &&
      newConfig.type === "INTEGER" &&
      newConfig.value !== undefined
    ) {
      integerValue.value = toInteger(newConfig.value);
    }
  },
  { deep: true }
);

onBeforeMount(async () => {
  id.value = currentRoute.value.params.id as string;
  level.value = currentRoute.value.params.level as string;
  ownerId.value = currentRoute.value.params.ownerId as string;
  console.log("Editing id :", id.value);
  if (id.value) {
    await getConfiguration(id.value, level.value, ownerId.value)
      .then((response) => {
        if (response) {
          // Handle potential data structure differences - ensure we map correctly
          const configData = {
            key: response.key || "",
            value: response.value || "",
            defaultValue: response.defaultValue || "",
            type: response.type || "",
            level: response.level || "",
            ownerId: response.ownerId || "",
            description: response.description || "",
            active: response.active || "",
            isPublic: response.isPublic || "",
            deleted: response.isDeleted || "",
          };
          // Direct assignment of the configuration object
          configuration.value = configData;

          // Set up derived values for boolean/integer types after initial assignment
          if (configData.type === "BOOLEAN") {
            booleanValue.value = configData.value === "true";
          } else if (configData.type === "INTEGER") {
            integerValue.value = toInteger(configData.value);
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching configuration:", error);
      });
  } else {
    // When creating new configuration, we might want to fetch settings
    // This is based on pattern from settings.service.ts but may not be needed here
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(pageName.value) + " " + _toDisplayString(_unref(t)("Common.Configuration")), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", null, [
              _createVNode(_unref(ElTooltip), {
                effect: "custom",
                placement: "left"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass([
                      'scrollable-tooltip-content',
                      {
                        'overflow-auto': isOverflowing(
                          _unref(t)('Configuration.NameTooltip')
                        ),
                      },
                    ])
                  }, _toDisplayString(_unref(t)("Configuration.NameTooltip")), 3)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.Name")), 1)
                ]),
                _: 1
              })
            ]),
            _createVNode(_unref(ElInput), {
              modelValue: configuration.value.key,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((configuration.value.key) = $event)),
              size: "small",
              readonly: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", null, [
              _createVNode(_unref(ElTooltip), {
                effect: "custom",
                placement: "left"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass([
                      'scrollable-tooltip-content',
                      {
                        'overflow-auto': isOverflowing(
                          _unref(t)('Configuration.DefaultValueTooltip')
                        ),
                      },
                    ])
                  }, _toDisplayString(_unref(t)("Configuration.DefaultValueTooltip")), 3)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.DefaultValue")), 1)
                ]),
                _: 1
              })
            ]),
            _createVNode(_unref(ElInput), {
              modelValue: configuration.value.defaultValue,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((configuration.value.defaultValue) = $event)),
              size: "small",
              readonly: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", null, [
              _createVNode(_unref(ElTooltip), {
                effect: "custom",
                placement: "left"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass([
                      'scrollable-tooltip-content',
                      {
                        'overflow-auto': isOverflowing(
                          _unref(t)('Configuration.DescriptionTooltip')
                        ),
                      },
                    ])
                  }, _toDisplayString(_unref(t)("Configuration.DescriptionTooltip")), 3)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.Description")), 1)
                ]),
                _: 1
              })
            ]),
            _createVNode(_unref(ElInput), {
              modelValue: configuration.value.description,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((configuration.value.description) = $event)),
              type: "textarea",
              rows: 3,
              readonly: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("label", null, [
              _createVNode(_unref(ElTooltip), {
                effect: "custom",
                placement: "left"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass([
                      'scrollable-tooltip-content',
                      {
                        'overflow-auto': isOverflowing(
                          _unref(t)('Configuration.ValueTooltip')
                        ),
                      },
                    ])
                  }, _toDisplayString(_unref(t)("Configuration.ValueTooltip")), 3)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.Value")), 1)
                ]),
                _: 1
              })
            ]),
            (configuration.value.type === 'BOOLEAN')
              ? (_openBlock(), _createBlock(_unref(ElSwitch), {
                  key: 0,
                  "active-color": "#5022a6",
                  modelValue: booleanValue.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((booleanValue).value = $event)),
                  disabled: !_unref(hasPermission)('CONFIGURATIONS.CONFIGURATION.SAVE')
                }, null, 8, ["modelValue", "disabled"]))
              : (configuration.value.type === 'INTEGER')
                ? (_openBlock(), _createBlock(_unref(ElInputNumber), {
                    key: 1,
                    size: "small",
                    modelValue: integerValue.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((integerValue).value = $event)),
                    disabled: !_unref(hasPermission)('CONFIGURATIONS.CONFIGURATION.SAVE')
                  }, null, 8, ["modelValue", "disabled"]))
                : (_openBlock(), _createBlock(_unref(ElInput), {
                    key: 2,
                    size: "small",
                    modelValue: configuration.value.value,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((configuration.value.value) = $event)),
                    disabled: !_unref(hasPermission)('CONFIGURATIONS.CONFIGURATION.SAVE')
                  }, null, 8, ["modelValue", "disabled"]))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_unref(ElButton), {
            class: "btn-oneTeg3",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(router).push('/configurations')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("Common.Back")), 1)
            ]),
            _: 1
          }),
          (_unref(hasPermission)('CONFIGURATIONS.CONFIGURATION.SAVE'))
            ? (_openBlock(), _createBlock(_unref(ElButton), {
                key: 0,
                class: "btn-oneTeg2",
                type: "primary",
                onClick: saveConfiguration
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("Common.Save")), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})